import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getFormAction } from "../../Actions/FormAction/FormAction";
import { getVisitAction } from "../../Actions/VisitAction/VisitAction";
import Select from "react-select";
const FollowUpModal = ({ closeModal, patientId }) => {
  const dispatch = useDispatch();
  const [state, setState] = useState({});
  const getForm = useSelector((state) => state.getForm);
  const { forms } = getForm;
  const [visit, setVisit] = useState([]);
  const [doctorId, setDoctorId] = useState([]);
  const [diseas, setDiseas] = useState([]);
  const [organ, setOrgan] = useState([]);
  const [organLevel, setOrganLevel] = useState([]);
  const [TYP, setTYP] = useState([]);

  const [load, setLoad] = useState(-1);

  const handleSelectVisit = (visit) => {
    setDoctorId([]);
    setOrgan([]);
    setDiseas([]);
    setTYP([]);
    setOrganLevel([]);
    setLoad(-1);
    if (visit == -1) {
      setVisit([]);
      setLoad(-1);

      return;
    } else {
      setLoad(1);
      setVisit(visit);
    }
  };
  useEffect(() => {
    dispatch(getFormAction([1]));
    dispatch(getVisitAction(patientId));
  }, [patientId]);

  const getVisit = useSelector((state) => state.getVisit);
  const { visits, loading } = getVisit;
  useEffect(() => {
    setDoctorId([{}]);
    if (visit.length <= 0) {
      return;
    }
    let tempInputValue = {};
    visit?.follow_up_commite?.map((follow) => {
      let tempDoctor = [];
      if (follow.doctor) {
        follow?.doctor?.map((dr) => {
          tempDoctor.push(dr);
        });
        setDoctorId([...doctorId, tempDoctor]);
      }

      let tempOrgan = [];
      if (follow.organ) {
        follow?.organ?.map((organ) => {
          tempOrgan.push(organ);
        });
        setOrgan([...organ, tempOrgan]);
      }

      let tempOrganLevel = [];
      if (follow.organ_level) {
        follow?.organ_level?.map((organ_level) => {
          tempOrganLevel.push(organ_level);
        });
        setOrganLevel([...organLevel, tempOrganLevel]);
      }

      let tempDiseas = [];
      if (follow.disease_type_specialist) {
        follow?.disease_type_specialist?.map((disease_type_specialist) => {
          tempDiseas.push(disease_type_specialist);
        });
        setDiseas([...diseas, tempDiseas]);
      }

      let tempTYP = [];
      if (follow.TYP) {
        follow?.TYP?.map((TYP) => {
          tempTYP.push(TYP);
        });
        setTYP([...TYP, tempTYP]);
      }

      if (follow.note == null || follow.note == undefined) {
        tempInputValue[follow.type] = null;
      } else {
        tempInputValue[follow.type] = follow.note;
      }
    });
    setState({ ...tempInputValue });
  }, [visit]);

  return (
    <React.Fragment>
      {loading ? (
        ""
      ) : (
        <div className="modal z-50 overflow-auto">
          <div className="modal-overlay">
            <div className="modal-container h-[90vh] overflow-auto w-11/12 mt-2">
              <div className="modal-header items-center justify-between flex gap-3">
                <h3 onClick={closeModal} className="cursor-pointer">
                  X
                </h3>

                <div>
                  <select
                    name=""
                    
                    onChange={(e) =>
                      handleSelectVisit(JSON.parse(e.target.value))
                    }
                    className="input w-full"
                    id=""
                  >
                    <option value="-1">Select Visit</option>
                    {visits?.map((visit, index) => {
                      return (
                        <option key={index} value={JSON.stringify(visit)}>
                          {visit?.created_at?.split("T")[0]}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              {load == 1 ? (
                <form action="" className="overflow-auto">
                  {forms?.map((form, formIndex) => {
                    return form.sectionForm.map((section, sectionIndex) => {
                      return (
                        <div>
                          <div
                            className="bg-teal-500 p-1.5 lg:w-3/12 my-2 m-auto rounded-sm text-white text-center shadow-md"
                            key={sectionIndex}
                          >
                            {section.title}
                          </div>
                          <div className="grid  grid-cols-1 lg:grid-cols-4 gap-3 my-2">
                            {section.field.map((field, index) => {
                              return (
                                <>
                                  {field.type == "text" ||
                                  field.type == "number" ||
                                  field.type == "dropdown" ? (
                                    <div className="flex flex-col">
                                      <div>
                                        <label htmlFor="">
                                          {field.label} *
                                        </label>
                                      </div>
                                      {field.type == "textarea" ? (
                                        ""
                                      ) : field.type == "dropdown" ? (
                                        <select
                                          key={index}
                                          className="p-1.5 input"
                                          type={field.type}
                                          name={field.name}
                                          placeholder={field.placeholder}
                                          id=""
                                        >
                                          <option value="">
                                            تکایە زانیاریەکە هەڵبژێرە
                                          </option>
                                          {field?.drop_down.map(
                                            (dropdown, index) => {
                                              return (
                                                <option
                                                  value={dropdown.value}
                                                  key={index}
                                                >
                                                  {dropdown.value}
                                                </option>
                                              );
                                            }
                                          )}
                                        </select>
                                      ) : (
                                        <input
                                          key={index}
                                          type={field.type}
                                          name={field.name}
                                          value={state[field.name] || ""}
                                          placeholder={field.placeholder}
                                          className="p-1.5  input"
                                        />
                                      )}
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </>
                              );
                            })}
                          </div>
                          <hr />
                        </div>
                      );
                    });
                  })}
                  <div className="grid grid-cols-2 md:grid-cols-3  lg:grid-cols-4 gap-2">
                    <div className="w-full flex flex-col">
                      <div>
                        <label htmlFor="">Doctor *</label>
                      </div>
                      <input type="text" className="input" value={doctorId} />
                    </div>
                    <div className="w-full flex flex-col">
                      <div className="">
                        <label htmlFor=""> Disease type specialist *</label>
                      </div>
                      <input type="text" className="input" value={diseas} />
                    </div>

                    <div className="w-full flex flex-col">
                      <div>Organ *</div>
                      <input type="text" className="input" value={organ} />
                    </div>

                    <div className="w-full flex flex-col">
                      <div>TYP *</div>
                      <input type="text" className="input" value={TYP} />
                    </div>

                    <div className="w-full flex flex-col">
                      <div>Organ Level *</div>
                      <input type="text" className="input" value={organLevel} />
                    </div>
                  </div>

                  {forms?.map((form, formIndex) => {
                    return form.sectionForm.map((section, sectionIndex) => {
                      return (
                        <div key={sectionIndex + formIndex}>
                          <div className="grid grid-cols-1 gap-2">
                            {section.field.map((field, index) => {
                              return (
                                <>
                                  {field.type == "textarea" ? (
                                    <div className="flex flex-col">
                                      <label htmlFor="">
                                        {field.label + " *"}
                                      </label>
                                      <div>
                                        <textarea
                                          key={index}
                                          type={field.type}
                                          name={field.name}
                                          value={state[field.name] || ""}
                                          placeholder={field.placeholder}
                                          className="input w-full"
                                          id=""
                                        ></textarea>
                                      </div>
                                    </div>
                                  ) : (
                                    ""
                                  )}
                                </>
                              );
                            })}
                          </div>
                        </div>
                      );
                    });
                  })}
                </form>
              ) : (
                "Select"
              )}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default FollowUpModal;
